import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DropdownArrow from '../../img/arrow_dropdown_prefs.png';

const StartTimeInputField = (props) => {
  return (
    <select
      name="limitStart"
      className="time-input-field"
      value={props.value}
      onChange={props.onChange}
      id={props.id}
      style={{ background: `url(${DropdownArrow}) no-repeat right` }}
    >
      {props.times.map((time, i) => (
        <option value={time.format('HH:mm')} key={i}>
          {time.format('LT')}
        </option>
      ))}
    </select>
  );
};

StartTimeInputField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  times: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
  id: PropTypes.string.isRequired,
};

export default StartTimeInputField;
